import { connect } from 'dva';
import { createForm } from 'rc-form';
import { Dashboard } from './Dashboard';
import { routerRedux } from 'dva/router';

const fetchActionOpen = 'application/fetchOpenApplicationForms';
const fetchActionClose = 'application/fetchCloseApplicationForms';

export const mapStateToProps = (state, ownProps) => {
  const { loading, authentication, application, config } = state;
  const { accessList, profile } = authentication;
  const isLoadingOpen = loading.effects[fetchActionOpen];
  const isLoadingClose = loading.effects[fetchActionClose];

  const {
    openApplicationFormsList,
    openApplicationFormsTotal,
    closedApplicationFormsList,
    closedApplicationFormsTotal
  } = application;
  const { requestFormsList, requestFormsTotal, companyAggerateRequest, userAggerateRequest } = config;

  return {
    isLoadingOpen,
    openApplicationFormsList,
    openApplicationFormsTotal,
    isLoadingClose,
    closedApplicationFormsList,
    closedApplicationFormsTotal,
    accessList,
    requestFormsList,
    requestFormsTotal,
    fetchActionOpen,
    fetchActionClose,
    companyAggerateRequest,
    userAggerateRequest,
    profile
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    redirect(pathname) {
      dispatch(routerRedux.push({ pathname: `${pathname}` }));
    },
    fetchRequestForms(data) {
      dispatch({ type: 'config/fetchAllRequestForms', payload: data });
    },
    fetchTotalCompanyRequest(data) {
      dispatch({ type: 'config/fetchCompanyRequestByStatus', payload: data });
    },
    fetchTotalUserRequest(data) {
      dispatch({ type: 'config/fetchUserRequestByStatus', payload: data });
    },
    fetchApplicationStats(data){ 
      dispatch({ type: 'application/fetchApplicationStats', payload : data })
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(createForm()(Dashboard));




